import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";
import { TriangleWarning } from "components/icons/TriangleWarning";
import { useModal } from "hooks/useModal";
import { useToast } from "hooks/useToast";
import React from "react";
import { useSetNoContractorsFoundMutation } from "store/apis/taskContractorsRequirements";
import { BackendError } from "types/utils/error";

export const NoContractorsFound = ({
  taskId,
  groupId,
  moveToNextState,
}: {
  taskId: string;
  groupId: string;
  moveToNextState: () => void;
}) => {
  const [setNoContractorsFound, { isLoading: isSettingNoContractors }] =
    useSetNoContractorsFoundMutation();
  const confirmModal = useModal();
  const { alertToast } = useToast();

  const handleClick = async () => {
    try {
      await setNoContractorsFound({
        taskId,
        groupId,
        isContractorsPresent: false,
      });
      moveToNextState();
      confirmModal.close();
    } catch (error) {
      alertToast({ message: (error as BackendError)?.data?.error?.message });
    }
  };

  return (
    <div className="t-mr-2">
      <Modal.Root onOpenChange={confirmModal.toggle} open={confirmModal.isOpen}>
        <Modal.Trigger asChild>
          <Button customType="danger">No contractors</Button>
        </Modal.Trigger>
        <Modal.Content size="small">
          <Modal.Body>
            <div>
              <span className="t-text-orange t-flex t-items-center t-justify-center t-w-10 t-h-10 t-rounded-full t-shadow-[0px_0px_0px_4px_rgba(255,220,78,0.15)] t-border t-border-orange-20 t-border-solid t-bg-yellow-20">
                <TriangleWarning />
              </span>
              <p className="t-mb-2 t-text-subtext t-mt-5">
                Confirm no contractors for this filing
              </p>
              <div className="t-text-body-sm t-text-text-30">
                You’re about to mark this Form 1099 filing as{" "}
                <b>completed with no contractors identified.</b>
              </div>
            </div>
          </Modal.Body>
          <Modal.FooterButtonGroup>
            <Modal.RawClose asChild>
              <Button>Cancel</Button>
            </Modal.RawClose>
            <Button
              isLoading={isSettingNoContractors}
              disabled={isSettingNoContractors}
              customType="primary"
              onClick={handleClick}
            >
              Yes, I confirm
            </Button>
          </Modal.FooterButtonGroup>
        </Modal.Content>
      </Modal.Root>
    </div>
  );
};
